"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _lodash = require("lodash");

var getBestPosition = function getBestPosition(_ref) {
  var x = _ref.x,
      y = _ref.y,
      relativeElement = _ref.relativeElement,
      _ref$relativeElementG = _ref.relativeElementGap,
      relativeElementGap = _ref$relativeElementG === void 0 ? 0 : _ref$relativeElementG,
      containerSize = _ref.containerSize,
      _ref$debug = _ref.debug,
      debug = _ref$debug === void 0 ? false : _ref$debug;

  if (debug) {
    console.log('parameter x ', x);
    console.log('parameter y ', y); // console.log('globalContainer ', globalContainer);

    console.log('relativeElement ', relativeElement);
    console.log('relativeElementGap ', relativeElementGap);
    console.log('containerSize ', containerSize);
  }

  var position = {
    x: (0, _lodash.last)(x),
    y: (0, _lodash.last)(y)
  };

  if (!relativeElement) {
    return position;
  } // const globalContainerRect = globalContainer.getBoundingClientRect();


  var relativeElementRect = relativeElement.getBoundingClientRect();
  var relativeElementRectHeight = relativeElementRect.bottom - relativeElementRect.top;
  var relativeElementRectWidth = relativeElementRect.right - relativeElementRect.left;
  var topAvailableArea = relativeElementRect.top - 0 - relativeElementGap;
  var bottomAvailableArea = document.documentElement.clientHeight - relativeElementRect.bottom - relativeElementGap;
  var leftAvailableArea = relativeElementRect.left - 0 - relativeElementGap;
  var rightAvailableArea = document.documentElement.clientWidth - relativeElementRect.right - relativeElementGap;
  var isTopVerticalCenterFit = topAvailableArea + relativeElementRectHeight / 2 > containerSize.height / 2;
  var isBottomVerticalCenterFit = bottomAvailableArea + relativeElementRectHeight / 2 > containerSize.height / 2;
  var isLeftHorizontalCenterFit = leftAvailableArea + relativeElementRectWidth / 2 > containerSize.width / 2;
  var isRightHorizontalCenterFit = rightAvailableArea + relativeElementRectWidth / 2 > containerSize.width / 2;

  if (debug) {
    console.log('leftAvailableArea ', leftAvailableArea, 'rightAvailableArea ', rightAvailableArea);
    console.log('topAvailableArea ', topAvailableArea, 'bottomAvailableArea ', bottomAvailableArea);
  }

  position.left = relativeElementRect.left;
  position.right = relativeElementRect.right;
  position.bottom = relativeElementRect.bottom;
  position.top = relativeElementRect.top;
  (0, _lodash.some)(y, function (currentY) {
    switch (currentY) {
      case 'bottom':
        if (bottomAvailableArea > containerSize.height) {
          position.y = 'bottom';
          return true;
        }

        break;

      case 'center':
        if (isTopVerticalCenterFit && isBottomVerticalCenterFit) {
          position.y = 'center';
          return true;
        }

        break;

      case 'top':
        if (topAvailableArea > containerSize.height) {
          position.y = 'top';
          return true;
        }

        break;

      default:
        return false;
    }

    return false;
  });
  (0, _lodash.some)(x, function (currentX) {
    switch (currentX) {
      case 'left':
        if (leftAvailableArea > containerSize.width) {
          position.x = 'left';
          return true;
        }

        break;

      case 'center':
        if (isLeftHorizontalCenterFit && isRightHorizontalCenterFit) {
          position.x = 'center';
          return true;
        }

        break;

      case 'right':
        if (rightAvailableArea > containerSize.width) {
          position.x = 'right';
          return true;
        }

        break;

      default:
        return false;
    }

    return false;
  });
  return position;
};

var _default = getBestPosition;
exports.default = _default;